// FAQS
function setup(section) {
    const faq_items = section.querySelectorAll('[data-question]');
    const category_selector = section.querySelectorAll('[data-category-selector]');
    const categories = section.querySelectorAll('[data-category]');
    // const faq_error = section.querySelector('.faq-template .error');
    
    Array.from(category_selector).forEach((item)=>item.addEventListener('click', (e) => {
        e.preventDefault();
    
        const cat = item.dataset.cat

        const categoryLabels = section.querySelectorAll('[data-category-header-label]');
        const categoryButtons = section.querySelectorAll('[data-category-selector]');
    
        Array.from(categoryLabels).forEach((label)=> {
            label.classList.toggle('active', label.dataset.cat == cat);
        }); 
        Array.from(categoryButtons).forEach((button)=> {
            button.classList.toggle('active', button.dataset.cat == cat);
        });   
        Array.from(categories).forEach((category)=> {
            category.classList.toggle('active', category.dataset.cat == cat);
        });
    
        let removeSpan = document.querySelectorAll('[data-question] p span');
        return Array.from(removeSpan).forEach(element => {
            element.classList.remove('highlight');
        });
    
    }));
    
    Array.from(faq_items).forEach((item)=>{
        item.querySelector('[data-faq-expand-btn]')
            ?.addEventListener('click', (e) => {
                e.preventDefault();
                const isNowActive = item.children[1].classList.toggle('expanded');
                item.classList.toggle('active', isNowActive)
                item.children[0].classList.toggle("active", isNowActive);
    
            })
    });
}


const faqSections = Array.from(document.querySelectorAll('[data-faq]'));
Array.from(faqSections).forEach((section)=>setup(section));